/**
 * Trigger haptic feedback when supported (mobile devices with Vibration API).
 * Uses a light tap pattern for subtle feedback.
 * Note: Not supported on iOS - Vibration API is Android/desktop only.
 */
export function haptic(): void {
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    navigator.vibrate(25)
  }
}
